import React from "react";
import ReactDOM from "react-dom";
import "./variables.css";
import "./index.css";
import App from "./main-component/App/App";
import * as serviceWorker from "./serviceWorker";
import "./css/font-awesome.min.css";
import "./css/themify-icons.css";
import "./css/flaticon.css";

import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/index";
import { Provider } from "react-redux";

const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>,
    document.getElementById("root")
  );
};

// Wait for the image-settings pre-fetch (fired in <head> before this bundle)
// so every AdminImageZoom useState initialiser gets the correct values and
// there is zero flash for ALL visitors — including first-time users.
//
// Promise.race caps the wait at 500 ms: on a warm API the settings JSON
// arrives in ~100 ms (well under), so the delay is invisible in practice.
// On a cold-start (>500 ms) we mount with defaults and the hook corrects
// values once the promise resolves — a brief adjustment is still better
// than a blank page.
if (window.__SITE_DESIGN_PROMISE__) {
  Promise.race([
    window.__SITE_DESIGN_PROMISE__,
    new Promise((resolve) => setTimeout(resolve, 500)),
  ]).then(renderApp);
} else {
  renderApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

